import React from 'react';
import { ArrowLeft, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import UserMenu from '@/components/UserMenu';
import { fileUrl } from './gameUtils';

function TeamScoreButton({ team, score, active, onClick, side }) {
  const logo = team.logo && (
    <img src={fileUrl(team.logo)} alt="" className="w-8 h-8 rounded-full bg-white object-cover border border-white/20" />
  );
  const isA = side === 'a';
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-2 py-1 rounded-lg transition-all ${active ? 'bg-white/10 ring-1 ring-amber-400/60' : 'opacity-70'}`}
      data-testid={`select-team-${side}`}>
      {isA && logo}
      <div className={isA ? 'text-right' : 'text-left'}>
        <div className="text-[10px] text-white/60 uppercase tracking-wider truncate max-w-[7rem]">{team.name}</div>
        <div className="text-2xl font-black leading-none tabular-nums" data-testid={`score-${side}`}>{score}</div>
      </div>
      {!isA && logo}
    </button>
  );
}

export function Scoreboard({ teamA, teamB, scoreA, scoreB, quarter, activeTeam, onSelectTeam, joinCode, onCopyJoinCode, onBack }) {
  return (
    <div className="bg-gradient-to-r from-[#001A5C] via-[#00247D] to-[#001A5C] px-3 py-2 flex items-center justify-between sticky top-0 z-40 shadow-lg shadow-black/30 border-b border-white/5"
      data-testid="scoreboard">
      <Button variant="ghost" size="sm" onClick={onBack}
        className="text-white/70 hover:text-white hover:bg-white/10">
        <ArrowLeft className="w-4 h-4" />
      </Button>
      <div className="flex items-center gap-3 text-center">
        <TeamScoreButton team={teamA} score={scoreA} side="a" active={activeTeam === 'a'} onClick={() => onSelectTeam('a')} />
        <div className="flex flex-col items-center px-1 text-white/60">
          <span className="text-[8px] uppercase tracking-widest">Quarter</span>
          <span className="bg-amber-400 text-black text-[11px] font-black px-2 py-0.5 rounded">Q{quarter > 4 ? `OT${quarter - 4}` : quarter}</span>
        </div>
        <TeamScoreButton team={teamB} score={scoreB} side="b" active={activeTeam === 'b'} onClick={() => onSelectTeam('b')} />
      </div>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onCopyJoinCode}
          title="Copy join code"
          className="text-white/70 hover:text-white text-[10px] font-mono bg-white/5 border border-white/10 hover:bg-white/10 h-7 px-2">
          <Copy className="w-3 h-3 mr-1" />{joinCode}
        </Button>
        <UserMenu inline={true} />
      </div>
    </div>
  );
}
